"use strict";
import "lodash";
import { svc_fetchAll, svc_addOne, svc_editOne, svc_deleteOne } from "@/services";
import { showServerResponse } from "@/utils/message";
import logger from "@/utils/logger";

const endpointBasePrefix = "pos_versions";

const Model = {
	namespace: "m_PosVersions",
	state: {
		posVersions: [],
	},
	reducers: {
		handleFetchAll(state, { payload: { posVersions } }) {
			return { ...state, posVersions };
		},
	},
	effects: {
		*fetchAll({ payload }, { call, put }) {
			let posVersions = yield call(svc_fetchAll, endpointBasePrefix);
			_.forEach(posVersions, function (row) {
				row.key = row.id;
			});

			yield put({
				type: "handleFetchAll",
				payload: { posVersions },
			});

			return posVersions;
		},
		*addOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(svc_addOne, endpointBasePrefix, payload);
			return showServerResponse(response);
		},
		*editOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(
				svc_editOne,
				endpointBasePrefix,
				payload,
				"id",
				payload.name,
			);
			return showServerResponse(response);
		},
		*deleteOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(
				svc_deleteOne,
				endpointBasePrefix,
				payload,
				"id",
				payload.name,
			);
			return showServerResponse(response);
		},
	},
	subscriptions: {},
};

export default Model;
